import { UNITS_LS_KEY } from "@/constants/unitsAndLocale";
import { createUnitsPlugin } from "@/plugins/Units";

const persistedUnits = localStorage.getItem(UNITS_LS_KEY);

export const unitsConverter = createUnitsPlugin({
  units: persistedUnits,
  fallbackUnits: "metric",
});
